/* eslint-disable import/no-anonymous-default-export */
import React from "react";
import { Button } from "semantic-ui-react";
import { Route } from 'react-router-dom'
import "./landing.css";

export default (props) => {
  return (
    <div
      className="main-wrapper"
      style={{
        display: "grid",
        gridColumn: "1/-1",
      }}
    >
      <div className="Image-wrapper">
        <img
          src={require("../images/hero-image-app.jpg")}
          alt="barber chair"
          style={{ width: "250px", marginBottom: "2rem", borderRadius: "8px" }}
        />
        <p style={{ textAlign: "center", color: "white" }}>
          Schedule Your Appointment - No Payment Required!
        </p>
      </div>
      <div className="Left-Col">
        
     

   
      <Route render={({ history}) => (
        <Button
          className="book-service-btn"
          onClick={(_) => {
            props.setPage(1);
            history.push('/booking')
          }}
        >
          Schedule an Appointment
        </Button>
         )} />
      </div>
    </div>
  );
};
